import React from 'react';
import { StyledGrid, StyledTypography } from 'components/AllocationStatusBadge/styles';

const ReadyForAuditBadge = () => (
  <StyledGrid className="ready-for-audit" data-testid="ready-for-audit-badge">
    <StyledTypography className="ready-for-audit">READY FOR AUDIT</StyledTypography>
  </StyledGrid>
);
export default ReadyForAuditBadge;
